import RadioButtonField from "../../../Utils/RadioButtonField"
import { careerProfileLabels } from "../../../Types/careerProfileLabels"
import styles from "../../../../../styles/Participant-Employment.module.css"
import { Button } from "primereact/button"
import { getStartAndEndDate } from "../../../Utils/Utils"
import EducationForm from "./EducationForm"
import { deleteConfirmationModal } from "../../../Utils/formikAux"
import NumberField from "../../../Utils/NumberField"
import EditorField from "../../../Utils/EditorField"
import { RadioButton } from "primereact/radiobutton"
import { Calendar } from "primereact/calendar"
import TextField from "../../../Utils/TextField"
const Education = ({
  formik,
  setEditEducationProgram,
  setEducationFormVisible,
  setDeleteEducationProgram,
  educationFormVisible,
  editEducationProgram,
  deleteEducationProgram,
  removeEducationProgram,
  viewExtraEducationSections,
}) => {
  const educationTable = () => {
    return (
      <table
        className={styles.table}
        style={{
          marginBottom: "1rem",
          paddingTop: "17px",
          paddingLeft: "16px",
          paddingBottom: "23px",
          paddingRight: "15px",
        }}
      >
        <thead>
          <tr>
            <th
              style={{
                fontSize: "14px",
                fontWeight: "700",
                lineHeight: "19px",
              }}
            >
              Educational/training institution
            </th>
            <th
              style={{
                fontSize: "14px",
                fontWeight: "700",
                lineHeight: "19px",
              }}
            >
              Years attended
            </th>
          </tr>
        </thead>
        <tbody>
          {formik.values.educationPrograms.map((e, index) => {
            return (
              <tr key={`${e.name}_${index}}`} style={{ height: "19px" }}>
                <td
                  style={{
                    fontSize: "14px",
                    fontWeight: "400",
                    lineHeight: "19px",
                  }}
                >
                  {e.name}
                </td>
                <td>
                  {getStartAndEndDate(
                    e.startDate,
                    e.endDate,
                    e.new || e.modified ? "" : "iso"
                  )}
                </td>
                <td>
                  {
                    <div className={styles.table_actions}>
                      <Button
                        icon="pi pi-pencil"
                        className={styles.rounded_btn}
                        onClick={() => {
                          setEditEducationProgram(e)
                          setEducationFormVisible(true)
                        }}
                      />
                      <Button
                        icon="pi pi-trash"
                        className={styles.rounded_btn}
                        onClick={() => {
                          setDeleteEducationProgram(e.id)
                        }}
                      />
                    </div>
                  }
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    )
  }
  const cleanExtraValues = () => {
    formik.setFieldValue(
      careerProfileLabels.education.education_6a.value,
      undefined
    )
    formik.setFieldValue(
      careerProfileLabels.education.education_6b.value,
      undefined
    )
    formik.setFieldValue(
      careerProfileLabels.education.education_6c.value,
      undefined
    )
    formik.setFieldValue(
      careerProfileLabels.education.education_6d.value,
      undefined
    )
    formik.setFieldValue(
      careerProfileLabels.education.education_6e.value,
      undefined
    )
    formik.setFieldValue(
      careerProfileLabels.education.education_6e1.value,
      undefined
    )
    formik.setFieldValue(
      careerProfileLabels.education.education_6f.value,
      undefined
    )
    formik.setFieldValue(
      careerProfileLabels.education.education_6g.value,
      undefined
    )
    formik.setFieldValue(
      careerProfileLabels.education.education_6h.value,
      undefined
    )
    formik.setFieldValue(
      careerProfileLabels.education.education_6i.value,
      undefined
    )
    formik.setFieldValue(
      careerProfileLabels.education.education_6j.value,
      undefined
    )
  }
  return (
    <>
      <RadioButtonField
        label={careerProfileLabels.education.education_1.label}
        value={formik.values.education_1}
        setValue={formik.setFieldValue}
        valueName={careerProfileLabels.education.education_1.value}
        callback={() => {
          if (formik.values.education_1 !== "No") {
            formik.setFieldValue(
              careerProfileLabels.education.education_1a.value,
              undefined
            )
          }
        }}
      />
      {formik.values.education_1 === "No" && (
        <RadioButtonField
          label={careerProfileLabels.education.education_1a.label}
          value={formik.values.education_1a}
          setValue={formik.setFieldValue}
          valueName={careerProfileLabels.education.education_1a.value}
          short
        />
      )}
      <RadioButtonField
        label={careerProfileLabels.education.education_2.label}
        value={formik.values.education_2}
        setValue={formik.setFieldValue}
        valueName={careerProfileLabels.education.education_2.value}
      />
      <RadioButtonField
        label={careerProfileLabels.education.education_3.label}
        value={formik.values.education_3}
        setValue={formik.setFieldValue}
        valueName={careerProfileLabels.education.education_3.value}
        callback={() => {
          if (formik.values.education_3 !== "Yes") {
            formik.setFieldValue(
              careerProfileLabels.education.education_3a.value,
              undefined
            )
          }
        }}
      />
      {formik.values.education_3 === "Yes" && (
        <NumberField
          label={careerProfileLabels.education.education_3a.label}
          maxValue={new Date().getFullYear()}
          setValue={formik.setFieldValue}
          value={formik.values.education_3a}
          minValue={1900}
          valueName={careerProfileLabels.education.education_3a.value}
          size={30}
        />
      )}
      <RadioButtonField
        label={careerProfileLabels.education.education_4.label}
        value={formik.values.education_4}
        setValue={formik.setFieldValue}
        valueName={careerProfileLabels.education.education_4.value}
        callback={() => {
          if (formik.values.education_4 !== "No") {
            formik.setFieldValue(
              careerProfileLabels.education.education_4a.value,
              undefined
            )
          }
        }}
      />
      {formik.values.education_4 === "Yes" && (
        <EditorField
          value={formik.values.education_4a}
          onTextChange={formik.setFieldValue}
          valueName={careerProfileLabels.education.education_4a.value}
          label={careerProfileLabels.education.education_4a.label}
        />
      )}
      <div className={`${styles.field} ${styles.education_wrapper}`}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "5px",
          }}
        >
          <label
            style={{
              paddingTop: "5px",
              fontSize: "16px",
              fontWeight: "600",
              color: "#383838",
            }}
          >
            Other education or training programs
          </label>
          <Button
            className={styles.button}
            style={{ height: "38px" }}
            label="Add new education"
            onClick={() => {
              setEducationFormVisible(true)
            }}
            type="button"
          />
        </div>
        {formik.values.educationPrograms?.length > 0 && educationTable()}

        <EducationForm
          setVisible={setEducationFormVisible}
          visible={educationFormVisible}
          edit={editEducationProgram}
          setValue={formik.setFieldValue}
          programs={formik.values.educationPrograms}
          setEdit={setEditEducationProgram}
        />
        {deleteConfirmationModal(
          deleteEducationProgram,
          setDeleteEducationProgram,
          removeEducationProgram,
          "education program"
        )}
      </div>
      <RadioButtonField
        label={careerProfileLabels.education.education_5.label}
        value={formik.values.education_5}
        setValue={formik.setFieldValue}
        valueName={careerProfileLabels.education.education_5.value}
        callback={() => {
          if (formik.values.education_5 !== "Yes") {
            formik.setFieldValue(
              careerProfileLabels.education.education_5a.value,
              undefined
            )
          }
        }}
      />
      {formik.values.education_5 === "Yes" && (
        <RadioButtonField
          label={careerProfileLabels.education.education_5a.label}
          value={formik.values.education_5a}
          setValue={formik.setFieldValue}
          valueName={careerProfileLabels.education.education_5a.value}
        />
      )}
      <div className={styles.field}>
        <label className={styles.label} style={{ marginBottom: "5px" }}>
          {careerProfileLabels.education.education_6.label}
        </label>
        <div className={styles.radio_btn_wrapper}>
          <div className={styles.radio_btn}>
            <RadioButton
              inputId={`Yes_6`}
              value={"Yes"}
              style={{ margin: "0" }}
              onChange={(e) => {
                viewExtraEducationSections(true)
                formik.setFieldValue(
                  careerProfileLabels.education.education_6.value,
                  e.value
                )
              }}
              checked={formik.values.education_6 === "Yes"}
            />
            <label htmlFor={`Yes_6`} className={styles.inline_label}>
              Yes
            </label>
          </div>
          <div className={styles.radio_btn}>
            <RadioButton
              inputId={`No_6`}
              value={"No"}
              style={{ margin: "0" }}
              onChange={(e) => {
                viewExtraEducationSections(false)
                formik.setFieldValue(
                  careerProfileLabels.education.education_6.value,
                  e.value
                )
                cleanExtraValues()
              }}
              checked={formik.values.education_6 === "No"}
            />
            <label htmlFor={`No_6`} className={styles.inline_label}>
              No
            </label>
          </div>
          <div className={styles.radio_btn}>
            <RadioButton
              inputId={`Unknown_6`}
              value={"Unknown"}
              style={{ margin: "0" }}
              onChange={(e) => {
                viewExtraEducationSections(false)
                formik.setFieldValue(
                  careerProfileLabels.education.education_6.value,
                  e.value
                )
                cleanExtraValues()
              }}
              checked={formik.values.education_6 === "Unknown"}
            />
            <label htmlFor={`Unknown_6`} className={styles.inline_label}>
              Unknown
            </label>
          </div>
        </div>
      </div>
      {formik.values.education_6 === "Yes" && (
        <>
          <EditorField
            value={formik.values.education_6a}
            onTextChange={formik.setFieldValue}
            valueName={careerProfileLabels.education.education_6a.value}
            label={careerProfileLabels.education.education_6a.label}
          />
          <EditorField
            value={formik.values.education_6b}
            onTextChange={formik.setFieldValue}
            valueName={careerProfileLabels.education.education_6b.value}
            label={careerProfileLabels.education.education_6b.label}
          />
          <EditorField
            value={formik.values.education_6c}
            onTextChange={formik.setFieldValue}
            valueName={careerProfileLabels.education.education_6c.value}
            label={careerProfileLabels.education.education_6c.label}
          />
          <EditorField
            value={formik.values.education_6d}
            onTextChange={formik.setFieldValue}
            valueName={careerProfileLabels.education.education_6d.value}
            label={careerProfileLabels.education.education_6d.label}
          />
          <div className={styles.field}>
            <label className={styles.label} style={{ marginBottom: "5px" }}>
              {careerProfileLabels.education.education_6e.label}
            </label>
            <div className={styles.radio_btn_wrapper}>
              <div className={styles.radio_btn}>
                <RadioButton
                  inputId={"ASAP"}
                  value={"ASAP"}
                  style={{ margin: "0" }}
                  onChange={(e) => {
                    formik.setFieldValue(
                      careerProfileLabels.education.education_6e.value,
                      e.value
                    )
                    formik.setFieldValue(
                      careerProfileLabels.education.education_6e1.value,
                      ""
                    )
                  }}
                  checked={formik.values.education_6e === "ASAP"}
                />
                <label htmlFor={"ASAP"} className={styles.inline_label}>
                  ASAP
                </label>
              </div>
              <div className={styles.radio_btn}>
                <RadioButton
                  inputId={"Within_the_next_week"}
                  value={"Within the next week"}
                  style={{ margin: "0" }}
                  onChange={(e) => {
                    formik.setFieldValue(
                      careerProfileLabels.education.education_6e.value,
                      e.value
                    )
                    formik.setFieldValue(
                      careerProfileLabels.education.education_6e1.value,
                      ""
                    )
                  }}
                  checked={
                    formik.values.education_6e === "Within the next week"
                  }
                />
                <label
                  htmlFor={"Within the next week"}
                  className={styles.inline_label}
                >
                  Within the next week
                </label>
              </div>
              <div className={styles.radio_btn}>
                <RadioButton
                  inputId={"Within_the_next_month"}
                  value={"Within the next month"}
                  style={{ margin: "0" }}
                  onChange={(e) => {
                    formik.setFieldValue(
                      careerProfileLabels.education.education_6e.value,
                      e.value
                    )
                    formik.setFieldValue(
                      careerProfileLabels.education.education_6e1.value,
                      ""
                    )
                  }}
                  checked={
                    formik.values.education_6e === "Within the next month"
                  }
                />
                <label
                  htmlFor={"Within the next month"}
                  className={styles.inline_label}
                >
                  Within the next month
                </label>
              </div>
              <div className={styles.radio_btn}>
                <RadioButton
                  inputId={"Within_the_next_6_months"}
                  value={"Within the next 6 months"}
                  style={{ margin: "0" }}
                  onChange={(e) => {
                    formik.setFieldValue(
                      careerProfileLabels.education.education_6e.value,
                      e.value
                    )
                    formik.setFieldValue(
                      careerProfileLabels.education.education_6e1.value,
                      ""
                    )
                  }}
                  checked={
                    formik.values.education_6e === "Within the next 6 months"
                  }
                />
                <label
                  htmlFor={"Within the next 6 months"}
                  className={styles.inline_label}
                >
                  Within the next 6 months
                </label>
              </div>
              <div className={styles.radio_btn}>
                <RadioButton
                  inputId={"On_a_specific_date"}
                  value={"On a specific date"}
                  style={{ margin: "0" }}
                  onChange={(e) => {
                    formik.setFieldValue(
                      careerProfileLabels.education.education_6e.value,
                      e.value
                    )
                  }}
                  checked={formik.values.education_6e === "On a specific date"}
                />
                <label
                  htmlFor={"On a specific date"}
                  className={styles.inline_label}
                >
                  On a specific date
                </label>
              </div>
            </div>
          </div>
          {formik.values.education_6e === "On a specific date" && (
            <Calendar
              style={{ marginBottom: "10px", width: "30%" }}
              value={formik.values.education_6e1}
              onChange={(e) => {
                formik.setFieldValue(
                  careerProfileLabels.education.education_6e1.value,
                  e.value
                )
              }}
              showIcon
            />
          )}
          <EditorField
            value={formik.values.education_6f}
            onTextChange={formik.setFieldValue}
            valueName={careerProfileLabels.education.education_6f.value}
            label={careerProfileLabels.education.education_6f.label}
          />
          <EditorField
            value={formik.values.education_6g}
            onTextChange={formik.setFieldValue}
            valueName={careerProfileLabels.education.education_6g.value}
            label={careerProfileLabels.education.education_6g.label}
          />
          <RadioButtonField
            label={careerProfileLabels.education.education_6h.label}
            value={formik.values.education_6h}
            setValue={formik.setFieldValue}
            valueName={careerProfileLabels.education.education_6h.value}
          />
          <RadioButtonField
            label={careerProfileLabels.education.education_6i.label}
            value={formik.values.education_6i}
            setValue={formik.setFieldValue}
            valueName={careerProfileLabels.education.education_6i.value}
          />
          {formik.values.education_6i === "Yes" && (
            <>
              <div style={{ marginBottom: "10px" }}>
                <TextField
                  label={careerProfileLabels.education.education_6i1.label}
                  setValue={formik.setFieldValue}
                  valueName={careerProfileLabels.education.education_6i1.value}
                  value={formik.values.education_6i1}
                />
              </div>
              <RadioButtonField
                label={careerProfileLabels.education.education_6i2.label}
                value={formik.values.education_6i2}
                setValue={formik.setFieldValue}
                valueName={careerProfileLabels.education.education_6i2.value}
                short
              />
              <RadioButtonField
                label={careerProfileLabels.education.education_6i3.label}
                value={formik.values.education_6i3}
                setValue={formik.setFieldValue}
                valueName={careerProfileLabels.education.education_6i3.value}
                short
              />
            </>
          )}
          <EditorField
            value={formik.values.education_6j}
            onTextChange={formik.setFieldValue}
            valueName={careerProfileLabels.education.education_6j.value}
            label={careerProfileLabels.education.education_6j.label}
          />
        </>
      )}
    </>
  )
}
export default Education
